import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/service_provider_withdraw_applications',
  component: Management,
  redirect: '/service_provider_withdraw_applications/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/service_provider_withdraw_applications/List'),
      meta: {
        auth: Auth.listServiceProviderWithdrawApplications
      },
      redirect: '/service_provider_withdraw_applications/list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/service_provider_withdraw_applications/ListTable'),
          meta: {
            auth: Auth.listServiceProviderWithdrawApplications,
            tabName: 'all'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/service_provider_withdraw_applications/ListTable'),
          meta: {
            auth: Auth.listServiceProviderWithdrawApplications,
            tabName: 'pending'
          }
        },
        {
          path: 'passed',
          component: () => import('@/views/service_provider_withdraw_applications/ListTable'),
          meta: {
            auth: Auth.listServiceProviderWithdrawApplications,
            tabName: 'passed'
          }
        },
        {
          path: 'transferred',
          component: () => import('@/views/service_provider_withdraw_applications/ListTable'),
          meta: {
            auth: Auth.listServiceProviderWithdrawApplications,
            tabName: 'transferred'
          }
        },
        {
          path: 'rejected',
          component: () => import('@/views/service_provider_withdraw_applications/ListTable'),
          meta: {
            auth: Auth.listServiceProviderWithdrawApplications,
            tabName: 'rejected'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/service_provider_withdraw_applications/New'),
      meta: {
        auth: Auth.createServiceProviderWithdrawApplication
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/service_provider_withdraw_applications/DetailLayout'),
      meta: {
        auth: Auth.showServiceProviderWithdrawApplication
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/service_provider_withdraw_applications/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showServiceProviderWithdrawApplication
          }
        }
      ]
    }
  ]
}
